export const SearchIconFilters = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="96"
    height="107"
    fill="none"
    viewBox="0 0 96 107"
  >
    <path
      fill="#EEF4FF"
      d="M91.008 36.049s-14.464 12.191.937 39.428c13.677 24.19-19.007 33.733-32.872 30.627-17.96-4.025-27.631-27.437-41.673-20.436C3.36 92.669-9.32 59.083 11.152 47.337c25.466-14.612 9.688-23.848 12.272-34.954C25.28 4.413 48.593-7.412 60.53 7.016c10.046 12.14 15.279 8.012 20.083 6.541 6.93-2.121 21.543 10.149 10.395 22.492"
    />
    <path
      fill="#1B1D4B"
      d="m74.01 18.168-31.211-5.114a4.2 4.2 0 0 0-4.824 3.465L27.18 82.398a4.2 4.2 0 0 0 3.465 4.824l31.21 5.114a4.2 4.2 0 0 0 4.825-3.465l10.795-65.88a4.2 4.2 0 0 0-3.466-4.823"
    />
    <path
      fill="#363BC4"
      d="M72.981 20.025 43.177 15.14a2.8 2.8 0 0 0-3.216 2.31L29.36 82.15a2.8 2.8 0 0 0 2.31 3.216l29.804 4.884a2.8 2.8 0 0 0 3.216-2.31L75.29 23.24a2.8 2.8 0 0 0-2.31-3.216"
    />
    <g clipPath="url(#clip0_7078_5912)">
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M55.266 51.88 48.1 50.702m1.604 5.169-2.388-.392m11.12-7.985-9.552-1.568m13.643 6.53.725-4.417c.33-2.007.494-3.01.23-3.84a3.63 3.63 0 0 0-1.31-1.823c-.701-.516-1.705-.68-3.71-1.01l-7.643-1.254c-2.007-.33-3.01-.494-3.84-.23a3.63 3.63 0 0 0-1.823 1.31c-.516.702-.68 1.705-1.01 3.711L42.11 57.323c-.33 2.006-.494 3.01-.23 3.84.234.73.692 1.368 1.31 1.822.702.517 1.705.681 3.711 1.01l3.224.53m12.539 2.057-1.497-2.085m1.684-2.79a4.235 4.235 0 1 1-8.36-1.37 4.235 4.235 0 0 1 8.36 1.37"
      />
    </g>
    <defs>
      <clipPath id="clip0_7078_5912">
        <path
          fill="#fff"
          d="m40.703 36 28.66 4.703-4.704 28.66L36 64.66z"
        />
      </clipPath>
    </defs>
  </svg>
);
